// Cupid icon — the silhouette at /public/cupid.png recolored via CSS mask.
//  variant: 'gradient' (theme gradient) | 'white' | 'solid' (flat terracotta)
// maskSize 112% zooms slightly past the PNG's transparent padding so the
// silhouette reads larger inside its box.
export default function CupidIcon({ size = 28, variant = 'gradient' }) {
  const bg = variant === 'white'
    ? '#fff'
    : variant === 'solid'
      ? '#C4826A'
      : 'linear-gradient(135deg, #C4826A 0%, #E0A98F 55%, #D98E72 100%)'
  return (
    <span aria-hidden style={{
      display:'inline-block', width:size, height:size, background:bg,
      WebkitMaskImage:'url(/cupid.png)', maskImage:'url(/cupid.png)',
      WebkitMaskRepeat:'no-repeat', maskRepeat:'no-repeat',
      WebkitMaskPosition:'center', maskPosition:'center',
      WebkitMaskSize:'112%', maskSize:'112%',
    }}/>
  )
}
